export type CaseFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type CaseFilterGroup = {
  id: string;
  label: string;
  options: CaseFilterOption[];
};

export const caseFilterGroups: CaseFilterGroup[] = [
  {
    id: 'brand',
    label: 'Hãng',
    options: [
      { value: '1st-player', label: '1St Player', keywords: ['1st player', '1stplayer'] },
      { value: 'asus', label: 'Asus', keywords: ['asus'] },
      { value: 'cooler-master', label: 'Cooler Master', keywords: ['cooler master'] },
      { value: 'corsair', label: 'Corsair', keywords: ['corsair'] },
      { value: 'deepcool', label: 'Deepcool', keywords: ['deepcool'] },
      { value: 'jetek', label: 'Jetek', keywords: ['jetek'] },
      { value: 'lian-li', label: 'Lian Li', keywords: ['lian li'] },
      { value: 'nzxt', label: 'NZXT', keywords: ['nzxt'] },
      { value: 'thermaltake', label: 'Thermaltake', keywords: ['thermaltake'] },
      { value: 'vsp', label: 'VSP', keywords: ['vsp'] },
      { value: 'xigmatek', label: 'Xigmatek', keywords: ['xigmatek'] },
      { value: 'adata', label: 'Adata', keywords: ['adata'] },
      { value: 'cougar', label: 'Cougar', keywords: ['cougar'] },
      { value: 'gigabyte', label: 'GIGABYTE', keywords: ['gigabyte', 'aorus'] },
      { value: 'golden-field', label: 'Golden Field', keywords: ['golden field'] },
      { value: 'magic', label: 'Magic', keywords: ['magic'] },
      { value: 'ares', label: 'Ares', keywords: ['ares'] },
      { value: 'mik', label: 'MIK', keywords: ['mik'] },
      { value: 'montech', label: 'Montech', keywords: ['montech'] },
      { value: 'msi', label: 'MSI', keywords: ['msi'] },
      { value: 'segotep', label: 'Segotep', keywords: ['segotep'] },
      { value: 'vitra', label: 'Vitra', keywords: ['vitra'] },
      { value: 'star', label: 'Star', keywords: ['star'] },
    ],
  },
  {
    id: 'case-type',
    label: 'Loại case',
    options: [
      { value: 'gaming', label: 'Case Gaming', keywords: ['case gaming', 'gaming case'] },
      {
        value: 'office',
        label: 'Case văn phòng',
        keywords: ['case van phong', 'case văn phòng', 'office case'],
      },
      { value: 'aquarium', label: 'Case hồ cá', keywords: ['case ho ca', 'aquarium'] },
      { value: 'with-fan', label: 'Case kèm fan', keywords: ['kem fan', 'kèm fan', 'co fan'] },
      {
        value: 'without-fan',
        label: 'Case không fan',
        keywords: ['khong fan', 'không fan', 'no fan'],
      },
    ],
  },
  {
    id: 'size',
    label: 'Kích thước',
    options: [
      { value: 'open-air', label: 'Open Air', keywords: ['open air'] },
      { value: 'atx-super-tower', label: 'ATX Super Tower', keywords: ['atx super tower'] },
      { value: 'atx-full-tower', label: 'ATX Full Tower', keywords: ['atx full tower'] },
      { value: 'atx-mid-tower', label: 'ATX Mid Tower', keywords: ['atx mid tower'] },
      { value: 'mini-atx', label: 'Mini ATX', keywords: ['mini atx'] },
      { value: 'mini-itx', label: 'Mini ITX', keywords: ['mini itx'] },
    ],
  },
  {
    id: 'mainboard-support',
    label: 'Hỗ trợ Main',
    options: [
      { value: 'mini-itx', label: 'Mini ITX', keywords: ['mini itx'] },
      { value: 'micro-atx', label: 'MicroATX', keywords: ['microatx', 'micro atx', 'matx'] },
      { value: 'atx', label: 'ATX', keywords: ['atx'] },
      { value: 'e-atx', label: 'E ATX', keywords: ['e atx', 'eatx'] },
      { value: 'eeb', label: 'EEB', keywords: ['eeb'] },
      { value: 'ceb', label: 'CEB', keywords: ['ceb'] },
    ],
  },
  {
    id: 'side-glass',
    label: 'Mặt hông kính',
    options: [
      { value: 'glass', label: 'Kính', keywords: ['kinh', 'kính', 'tempered glass'] },
      {
        value: 'no-glass',
        label: 'Không có',
        keywords: ['khong co', 'không có', 'no glass'],
      },
    ],
  },
];
